import { Button, Flex, Modal, Typography } from '@iheartjane/reefer';
import { useEffect } from 'react';

import { postMessageToIframeParent } from '@jane/shared/util';

export const EmbedRedirectModal = ({ href }: { href: string }) => {
  useEffect(() => {
    postMessageToIframeParent({
      messageType: 'scrollToTop',
    });
    postMessageToIframeParent({
      messageType: 'openModal',
    });

    return () => {
      postMessageToIframeParent({
        messageType: 'closeModal',
      });
    };
  }, []);

  return (
    <Modal
      open
      variant="dialogue"
      overlayClose={false}
      onRequestClose={() => null}
      topOverride="160px"
    >
      <Flex maxWidth={325} flexDirection="column" p={24}>
        <Typography variant="h2-semibold" textAlign="center" branded>
          Oops! This menu is no longer in use
        </Typography>
        <Typography textAlign="center" mt={8}>
          Click continue below to be redirected to our newest menu.
        </Typography>

        <Button full label="Continue" mt={24} href={href} />
      </Flex>
    </Modal>
  );
};
